// hooks
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import useAuth from 'src/hooks/useAuth';
// material
import { experimentalStyled as styled } from '@mui/material/styles';
import { Box, Button, Container, Typography } from '@mui/material';
// layouts
import LogoOnlyLayout from 'src/components/layouts/LogoOnlyLayout';
// routes
import { INITIAL_PATH } from 'src/constants';
// components
import { AddTotpDeviceForm } from './components/form';
import { MfaSetNavigation, mfaSetFlowPaths } from './SelectMfaMethod';
import { ConfirmDialog } from './components/ConfirmDialog';
import Page from 'src/components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
/**
 * TOTPデバイス登録画面
 * @return コンポーネント
 */
export const AddTotpDevice = () => {
  // hooks
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation();
  const { isAuthenticated, isRequiredMfa, isMfaAuthenticated } = useAuth();
  // state
  const [navigationPaths, setNavigationPaths] = useState<MfaSetNavigation>(mfaSetFlowPaths);
  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false);
  //  認証完了済みフラグ(MFA不要でID/Pass認証済み、またはMFA必須でMFA認証済みの場合True)
  const isAuthed = (!isRequiredMfa && isAuthenticated) || (isRequiredMfa && isMfaAuthenticated);

  // 初期表示処理
  useEffect(() => {
    // 画面遷移先設定
    if (state?.navigationPaths) {
      setNavigationPaths(state.navigationPaths);
    }
  }, [state?.navigationPaths]);

  // 戻る処理
  const handleBack = async () => {
    if (navigationPaths?.back) {
      // 前画面へ遷移
      return navigate(navigationPaths.back, { replace: true, state: { caller: navigationPaths.caller } });
    }
    return navigate(INITIAL_PATH, { replace: true });
  };

  // 戻るボタン押下時処理
  const confirmBack = async () => {
    setConfirmDialogOpen(true);
  };

  return (
    <RootStyle title="Device Registration for TOTP | Minimal UI">
      <LogoOnlyLayout />
      <Container>
        <Box sx={{ maxWidth: 480, mx: 'auto' }}>
          <Typography variant="h3" paragraph>
            {t('mfa.title.addTotpDevice')}
          </Typography>
          {/* TOTPデバイス登録form */}
          <AddTotpDeviceForm navigationPaths={navigationPaths} />
          <Button fullWidth size="large" sx={{ mt: 1 }} onClick={confirmBack}>
            {t('button.back')}
          </Button>
          {/* 戻るボタン押下時の確認ダイアログ */}
          {isConfirmDialogOpen && (
            <ConfirmDialog
              setIsDialogOpen={setConfirmDialogOpen}
              handleOk={handleBack}
              dialogContents={<Trans i18nKey={isAuthed ? 'mfa.addTotpDevice.confirmBackAuthed' : 'mfa.addTotpDevice.confirmBack'} />}></ConfirmDialog>
          )}
        </Box>
      </Container>
    </RootStyle>
  );
};
